import { atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const productSamplesModalAtom = atom(false, "productSamplesModal").pipe(
  withLocalStorage("productSamplesModal"),
);
